import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseCreateResource } from '../../utils/types';

type CargoInput = TrpcInputs['createCargo'];
type CargoOutput = TrpcOutputs['createCargo'];

type CreateCargoMutate = MutateFunction<CargoInput, CargoOutput>;
type UseCreateCargo = UseCreateResource<CargoInput, CargoOutput>;

export const useCreateCargo = (requestId?: number): UseCreateCargo => {
  const { mutateAsync: createAsync, isLoading, error } = trpc.createCargo.useMutation();

  const create: CreateCargoMutate = (args) => createAsync({ request_id: requestId, ...args } as CargoInput);
  const createDefault: CreateCargoMutate = () =>
    createAsync({
      request_id: requestId,
      quantity: 0,
      width: 0,
      height: 0,
      length: 0,
      weight: 0,
    } as CargoInput);

  return {
    create,
    createDefault,
    isLoading,
    error: error?.message,
  };
};
